// extracted by mini-css-extract-plugin
module.exports = {"navbar_icon":"NavDropdown_navbar_icon__gWKvl","nav_dropdown":"NavDropdown_nav_dropdown__jmP2Y"};